"use strict";
var XidaxCompat = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // app/lib/compat/theme-entry.ts
  var theme_entry_exports = {};
  __export(theme_entry_exports, {
    ALL_RULE_IDS: () => ALL_RULE_IDS,
    COMPAT_ENGINE_VERSION: () => COMPAT_ENGINE_VERSION,
    XIDAX_SLOTS: () => XIDAX_SLOTS,
    canAdd: () => canAdd,
    candidateReason: () => candidateReason,
    cheapestFitting: () => cheapestFitting,
    evaluate: () => evaluate,
    explainCandidate: () => explainCandidate,
    missingRequirementsMessage: () => missingRequirementsMessage,
    plan: () => plan,
    powerBalance: () => powerBalance,
    readiness: () => readiness,
    requirementsFromSlots: () => requirementsFromSlots,
    slotCapacity: () => slotCapacity,
    toPart: () => toPart,
    xidaxContext: () => xidaxContext
  });

  // app/lib/compat/normalize.ts
  function asList(v) {
    if (v == null)
      return [];
    if (Array.isArray(v))
      return cleanInto(v);
    if (typeof v !== "string")
      return [String(v)];
    const s = v.trim();
    if (s.length > 1 && (s[0] === "[" || s[0] === "{")) {
      try {
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed))
          return cleanInto(parsed);
        if (parsed != null)
          return [String(parsed).trim()];
      } catch {
      }
    }
    if (s.indexOf(",") !== -1)
      return cleanInto(s.split(","));
    return s ? [s] : [];
  }
  function cleanInto(src) {
    const out = [];
    for (let i = 0; i < src.length; i++) {
      const t = String(src[i]).trim();
      if (t)
        out.push(t);
    }
    return out;
  }
  function sockNorm(s) {
    if (s == null)
      return "";
    return String(s).trim().toUpperCase().replace(/^(LGA|SOCKET\s*)/, "");
  }
  function sockEq(a, b) {
    const na = sockNorm(a);
    return na === sockNorm(b) && na !== "";
  }
  function sockInList(needle, haystack) {
    if (!needle || !haystack || !haystack.length)
      return false;
    const n = sockNorm(needle);
    return haystack.some((x) => sockNorm(x) === n);
  }
  function posNum(v) {
    if (v == null || v === "")
      return null;
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0)
      return null;
    return n;
  }
  function num(v) {
    if (v == null || v === "")
      return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }
  function intersects(a, b) {
    return a.some((x) => b.includes(x));
  }

  // app/lib/compat/totals.ts
  function partInSlot(state, slot) {
    for (const p of state.parts)
      if (p.slot === slot)
        return p;
    return null;
  }
  function partsInSlot(state, slot) {
    return state.parts.filter((p) => p.slot === slot);
  }
  function indexBySlot(state) {
    const bySlot = /* @__PURE__ */ new Map();
    const parts = state.parts;
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i];
      const existing = bySlot.get(p.slot);
      if (existing)
        existing.push(p);
      else
        bySlot.set(p.slot, [p]);
    }
    return bySlot;
  }
  function unitsBySlot(state) {
    const out = /* @__PURE__ */ new Map();
    const parts = state.parts;
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i];
      out.set(p.slot, (out.get(p.slot) ?? 0) + unitsFor(p));
    }
    return out;
  }
  function unitsFor(part) {
    const lines = Number.isFinite(part.lineQty) && part.lineQty > 0 ? part.lineQty : 1;
    const per = Number.isFinite(part.unitsPerVariant) && part.unitsPerVariant > 0 ? part.unitsPerVariant : 1;
    return lines * per;
  }
  function sumOverSlot(state, slot, pick) {
    let total = 0;
    for (const p of partsInSlot(state, slot)) {
      const v = pick(p);
      if (v == null || !Number.isFinite(v))
        continue;
      total += v * unitsFor(p);
    }
    return total;
  }
  function sumOverBuild(state, pick) {
    let total = 0;
    for (const p of state.parts) {
      const v = pick(p);
      if (v == null || !Number.isFinite(v))
        continue;
      total += v * unitsFor(p);
    }
    return total;
  }

  // app/lib/compat/budgets.ts
  var BUDGET_ORDER = [
    "cpus",
    "dimms",
    "pcie",
    "sata",
    "m2_nvme",
    "m2_sata",
    "m2_combo",
    "bay_25",
    "bay_35",
    "bay_525",
    "case_fans"
  ];
  var BUDGETS = {
    cpus: { supplyRole: "board", label: "CPU sockets" },
    dimms: { supplyRole: "board", fallbackRole: "chassis", label: "memory slots" },
    pcie: { supplyRole: "board", label: "PCIe slots" },
    sata: { supplyRole: "board", label: "SATA ports" },
    // NVMe drains the shared combo socket before SATA does — array order in
    // balanceComboSlots (Product.php:1301-1321), preserved deliberately because it
    // decides WHICH drive is rejected when both overflow.
    m2_nvme: { supplyRole: "board", label: "M.2 NVMe slots", spill: "m2_combo", spillOrder: 0 },
    m2_sata: { supplyRole: "board", label: "M.2 SATA slots", spill: "m2_combo", spillOrder: 1 },
    m2_combo: { supplyRole: "board", label: "M.2 combo slots", spilloverOnly: true },
    bay_25: { supplyRole: "chassis", label: '2.5" bays', clampTo: "sata" },
    bay_35: { supplyRole: "chassis", label: '3.5" bays', clampTo: "sata" },
    bay_525: { supplyRole: "chassis", label: '5.25" bays', clampTo: "sata" },
    // NOT clamped: its column is `case_fan_slot_count`, which does not start with
    // `slot_count_`, so PrestaShop's clamp never applied to it.
    case_fans: { supplyRole: "chassis", label: "fan headers" }
  };
  function installedMemoryGb(state, ctx) {
    return sumOverSlot(state, ctx.roles.ram, (p) => p.specs.memorySizeGb);
  }
  function computeBudgets(state, ctx) {
    const out = {};
    for (let i = 0; i < BUDGET_ORDER.length; i++) {
      const key = BUDGET_ORDER[i];
      out[key] = {
        key,
        label: BUDGETS[key].label,
        supply: null,
        used: 0,
        spilledOut: 0,
        spilledIn: 0,
        clamped: false,
        consumers: []
      };
    }
    const boardSlot = ctx.roles.board;
    const chassisSlot = ctx.roles.chassis;
    const parts = state.parts;
    let sawBoard = false;
    let sawChassis = false;
    let fallback = null;
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i];
      const isBoard = p.slot === boardSlot;
      const isChassis = p.slot === chassisSlot;
      if (isBoard)
        sawBoard = true;
      if (isChassis)
        sawChassis = true;
      const supplied = p.specs.budgets;
      if (supplied && (isBoard || isChassis)) {
        for (const k in supplied) {
          const def = BUDGETS[k];
          if (!def)
            continue;
          const primary = def.supplyRole === "board" ? isBoard : isChassis;
          const backup = def.fallbackRole === "board" ? isBoard : def.fallbackRole === "chassis" && isChassis;
          if (!primary && !backup)
            continue;
          const v = posNum(supplied[k]);
          if (v == null)
            continue;
          if (!primary) {
            fallback = fallback || {};
            fallback[k] = (fallback[k] ?? 0) + v;
            continue;
          }
          const b = out[k];
          b.supply = (b.supply ?? 0) + v;
        }
      }
      const consumed = p.specs.uses;
      if (!consumed)
        continue;
      let units = -1;
      for (const k in consumed) {
        const def = BUDGETS[k];
        if (!def || def.spilloverOnly)
          continue;
        if (def.supplyRole === "board" ? isBoard : isChassis)
          continue;
        const per = posNum(consumed[k]);
        if (per == null)
          continue;
        if (units < 0)
          units = unitsFor(p);
        const b = out[k];
        b.used += per * units;
        b.consumers.push(p);
      }
    }
    if (fallback) {
      for (const k in fallback) {
        const key = k;
        const present = BUDGETS[key].supplyRole === "board" ? sawBoard : sawChassis;
        if (!present)
          out[key].supply = fallback[key];
      }
    }
    for (const key of BUDGET_ORDER) {
      const def = BUDGETS[key];
      if (!def.clampTo)
        continue;
      const cap = out[def.clampTo].supply;
      const mine = out[key].supply;
      if (cap != null && mine != null && cap < mine) {
        out[key].supply = cap;
        out[key].clamped = true;
      }
    }
    const spillers = BUDGET_ORDER.filter((k) => BUDGETS[k].spill != null).sort(
      (a, b) => (BUDGETS[a].spillOrder ?? 0) - (BUDGETS[b].spillOrder ?? 0)
    );
    for (const key of spillers) {
      const target = BUDGETS[key].spill;
      const b = out[key];
      const pool = out[target];
      if (b.supply == null || pool.supply == null)
        continue;
      const overflow = b.used - b.supply;
      if (overflow <= 0)
        continue;
      const room = pool.supply - pool.used;
      if (room <= 0)
        continue;
      const moved = Math.min(overflow, room);
      b.used -= moved;
      b.spilledOut += moved;
      pool.used += moved;
      pool.spilledIn += moved;
    }
    return out;
  }
  function overBudget(budgets) {
    return BUDGET_ORDER.map((k) => budgets[k]).filter(
      (b) => b.supply != null && b.used > b.supply
    );
  }

  // app/lib/compat/rules.ts
  function absent(readings) {
    const out = [];
    for (const key in readings) {
      const v = readings[key];
      if (v == null || v === "")
        out.push(key);
    }
    return out;
  }
  var mm = (v) => `${v}mm`;
  var RULES = [
    // ── CPU ↔ board ───────────────────────────────────────────────────────────
    {
      id: "cpu_mobo_socket",
      missingSpecs: (board, cpu) => absent({ "board.socket": (board.socket || [])[0], "cpu.socket": (cpu.socket || [])[0] }),
      severity: "block",
      subject: "board",
      counterpart: "cpu",
      fires: (board, cpu) => {
        const a = (board.socket || [])[0];
        const b = (cpu.socket || [])[0];
        return !!a && !!b && !sockEq(a, b);
      },
      reason: () => "Socket does not match selected CPU",
      notice: (_b, cpu, label) => label ? `Swapped motherboard to ${label} to match the ${(cpu.socket || [])[0]} platform.` : `No compatible motherboard available for ${(cpu.socket || [])[0]}; please pick one manually.`,
      detail: (board, cpu) => `${(board.socket || [])[0]} vs ${(cpu.socket || [])[0]}`,
      // PrestaShop swaps whichever side the customer did NOT just touch
      // (Cart.php:815-822): pick a CPU, the board flips.
      remedyFor: (ctx, last) => ({
        kind: "replace",
        slot: last === ctx.roles.cpu ? ctx.roles.board : ctx.roles.cpu,
        strategy: "cheapest-satisfying"
      })
    },
    {
      id: "cpu_mobo_chipset",
      missingSpecs: (board, cpu) => absent({ "board.chipsetVendor": board.chipsetVendor, "cpu.chipsetVendor": cpu.chipsetVendor }),
      severity: "block",
      subject: "board",
      counterpart: "cpu",
      fires: (board, cpu) => !!board.chipsetVendor && !!cpu.chipsetVendor && board.chipsetVendor !== cpu.chipsetVendor,
      reason: () => "CPU manufacturer mismatch",
      notice: (_b, cpu, label) => label ? `Swapped motherboard to ${label} to match the ${cpu.chipsetVendor} platform.` : `No compatible motherboard available for ${cpu.chipsetVendor}; please pick one manually.`,
      detail: (board, cpu) => `${board.chipsetVendor} vs ${cpu.chipsetVendor}`,
      remedyFor: (ctx, last) => ({
        kind: "replace",
        slot: last === ctx.roles.cpu ? ctx.roles.board : ctx.roles.cpu,
        strategy: "cheapest-satisfying"
      })
    },
    // ── board ↔ chassis ───────────────────────────────────────────────────────
    {
      id: "mobo_case_form_factor",
      missingSpecs: (board, chassis) => absent({ "board.formFactor": (board.formFactor || [])[0], "case.formFactor": (chassis.formFactor || [])[0] }),
      severity: "block",
      subject: "board",
      counterpart: "chassis",
      fires: (board, chassis) => {
        const allowed = chassis.formFactor || [];
        const mine = board.formFactor || [];
        return allowed.length > 0 && mine.length > 0 && !intersects(mine, allowed);
      },
      reason: () => "Form factor not supported by selected case",
      notice: (_b, _c, label) => label ? `Swapped motherboard to ${label} to fit the case.` : "Removed motherboard \u2014 none fit the selected case.",
      detail: (board, chassis) => `${(board.formFactor || []).join("/")} not in ${(chassis.formFactor || []).join("/")}`,
      // Asymmetric on purpose, preserved from the theme: when the chassis was just
      // chosen the board is swapped, but when the BOARD was just chosen the chassis
      // is never auto-swapped — PrestaShop doesn't, so the customer is advised
      // instead ("pick a larger case").
      remedyFor: (ctx, last) => last === ctx.roles.board ? { kind: "manual", slot: ctx.roles.chassis } : { kind: "replace", slot: ctx.roles.board, strategy: "cheapest-satisfying" }
    },
    // ── cooler ────────────────────────────────────────────────────────────────
    {
      id: "cooler_case_height",
      missingSpecs: (cooler, chassis) => absent({ "cooler.heightMm": posNum(cooler.heightMm), "case.clearance.coolerMm": posNum(chassis.clearance?.coolerMm) }),
      severity: "block",
      subject: "cooler",
      counterpart: "chassis",
      fires: (cooler, chassis) => {
        const mine = posNum(cooler.heightMm);
        const cap = posNum(chassis.clearance?.coolerMm);
        return mine != null && cap != null && mine > cap;
      },
      reason: (cooler, chassis) => `Cooler too tall for case (${mm(posNum(cooler.heightMm))} > ${mm(posNum(chassis.clearance?.coolerMm))})`,
      notice: () => "Removed CPU cooler \u2014 too tall for the case.",
      detail: (cooler, chassis) => `${mm(posNum(cooler.heightMm))} > ${mm(posNum(chassis.clearance?.coolerMm))}`,
      remedyFor: (ctx) => ({ kind: "remove", slot: ctx.roles.cooler })
    },
    {
      id: "cooler_cpu_socket",
      missingSpecs: (cooler, cpu) => absent({ "cooler.socket": (cooler.socket || [])[0], "cpu.socket": (cpu.socket || [])[0] }),
      severity: "block",
      subject: "cooler",
      counterpart: "cpu",
      fires: (cooler, cpu) => {
        const supported = cooler.socket || [];
        const need = (cpu.socket || [])[0];
        return supported.length > 0 && !!need && !sockInList(need, supported);
      },
      reason: () => "Cooler does not support selected CPU socket",
      notice: (_cool, cpu) => `Removed CPU cooler \u2014 doesn't support the ${(cpu.socket || [])[0]} socket.`,
      detail: (cooler, cpu) => `${(cpu.socket || [])[0]} not in ${(cooler.socket || []).join("/")}`,
      remedyFor: (ctx) => ({ kind: "remove", slot: ctx.roles.cooler })
    },
    {
      id: "cooler_cpu_thermal",
      missingSpecs: (cooler, cpu) => absent({ "cooler.thermalWatts": posNum(cooler.thermalWatts), "cpu.wattsPerUnit": posNum(cpu.wattsPerUnit) }),
      severity: "block",
      subject: "cooler",
      counterpart: "cpu",
      // Cart.php:746-755. Never ported to Shopify, and it has NO HTML footprint —
      // only the PrestaShop source revealed it existed. So a 65W cooler on a 170W
      // Threadripper has been orderable this whole time.
      //
      // Both sides read the SAME PrestaShop column, `wattage_requirement`, because it
      // is overloaded: draw on a CPU, thermal capacity on a cooler. The adapter
      // splits them into wattsPerUnit and thermalWatts, which is what lets this rule
      // be written as the comparison it actually is rather than a column against
      // itself. Cat 12 processors range 20-350; cat 46 coolers 75-500.
      //
      // Per-unit on both sides, deliberately un-multiplied: a cooler cools one CPU,
      // so quantity does not enter it.
      fires: (cooler, cpu) => {
        const capacity = posNum(cooler.thermalWatts);
        const draw = posNum(cpu.wattsPerUnit);
        return capacity != null && draw != null && capacity < draw;
      },
      reason: (cooler, cpu) => `Not rated for the selected CPU (${posNum(cooler.thermalWatts)}W cooler, ${posNum(cpu.wattsPerUnit)}W CPU)`,
      // PrestaShop's exact wording, and it attempts NO replacement — the cooler is
      // simply removed and the customer is asked to choose again.
      notice: () => "The chosen Cooler is not strong enough for your processor, and has been removed.",
      detail: (cooler, cpu) => `${posNum(cooler.thermalWatts)}W < ${posNum(cpu.wattsPerUnit)}W`,
      remedyFor: (ctx) => ({ kind: "remove", slot: ctx.roles.cooler })
    },
    // ── RAM ↔ board ───────────────────────────────────────────────────────────
    {
      id: "ram_mobo_type",
      missingSpecs: (ram, board) => absent({ "ram.memoryType": (ram.memoryType || [])[0], "board.memoryType": (board.memoryType || [])[0] }),
      severity: "block",
      subject: "ram",
      counterpart: "board",
      fires: (ram, board) => {
        const allowed = board.memoryType || [];
        const mine = ram.memoryType || [];
        return allowed.length > 0 && mine.length > 0 && !intersects(mine, allowed);
      },
      reason: () => "Memory type not supported by motherboard",
      notice: (_r, board, label) => label ? `Swapped memory to ${label} (${(board.memoryType || [])[0]}).` : "Removed memory \u2014 no matching type for the selected motherboard.",
      detail: (ram, board) => `${(ram.memoryType || []).join("/")} not in ${(board.memoryType || []).join("/")}`,
      // Always the RAM, never the board — PrestaShop Cart.php:889-902.
      remedyFor: (ctx) => ({ kind: "replace", slot: ctx.roles.ram, strategy: "cheapest-satisfying" })
    },
    // ── chassis clearances ────────────────────────────────────────────────────
    {
      id: "gpu_case_length",
      missingSpecs: (gpu, chassis) => absent({ "gpu.lengthMm": posNum(gpu.lengthMm), "case.clearance.gpuMm": posNum(chassis.clearance?.gpuMm) }),
      severity: "block",
      subject: "gpu",
      counterpart: "chassis",
      fires: (gpu, chassis) => {
        const mine = posNum(gpu.lengthMm);
        const cap = posNum(chassis.clearance?.gpuMm);
        return mine != null && cap != null && mine > cap;
      },
      reason: (gpu, chassis) => `GPU too long for case (${mm(posNum(gpu.lengthMm))} > ${mm(posNum(chassis.clearance?.gpuMm))})`,
      notice: (gpu, chassis) => `Removed graphics card \u2014 too long for the case (${mm(posNum(gpu.lengthMm))} > ${mm(posNum(chassis.clearance?.gpuMm))}).`,
      detail: (gpu, chassis) => `${mm(posNum(gpu.lengthMm))} > ${mm(posNum(chassis.clearance?.gpuMm))}`,
      remedyFor: (ctx) => ({ kind: "remove", slot: ctx.roles.gpu })
    },
    {
      id: "psu_case_length",
      missingSpecs: (psu, chassis) => absent({ "psu.lengthMm": posNum(psu.lengthMm), "case.clearance.psuMm": posNum(chassis.clearance?.psuMm) }),
      severity: "block",
      subject: "psu",
      counterpart: "chassis",
      fires: (psu, chassis) => {
        const mine = posNum(psu.lengthMm);
        const cap = posNum(chassis.clearance?.psuMm);
        return mine != null && cap != null && mine > cap;
      },
      // Verbatim from the theme, which omits the measurements here even though it
      // includes them for the GPU. Kept as-is; wording changes belong in PR 2.
      reason: () => "PSU too long for case",
      notice: () => "Removed power supply \u2014 too long for the case.",
      detail: (psu, chassis) => `${mm(posNum(psu.lengthMm))} > ${mm(posNum(chassis.clearance?.psuMm))}`,
      remedyFor: (ctx) => ({ kind: "remove", slot: ctx.roles.psu })
    }
  ];
  var RULES_BY_ID = Object.fromEntries(
    RULES.map((r) => [r.id, r])
  );
  var ALL_RULE_IDS = [];
  function requiredWatts(draw, ctx) {
    if (draw <= 0)
      return 0;
    return Math.ceil((draw + ctx.policy.psuBaseOverheadW) * ctx.policy.psuMargin);
  }
  var BUILD_RULES = [
    {
      id: "psu_wattage",
      // ADVISORY, not blocking — deliberately.
      //
      // PrestaShop does not block either: it warns and then AUTO-UPGRADES the PSU
      // (Cart.php:1202-1336), and that upgrade is PR 8. The theme's own dead
      // `wattsWarning` getter was a passive banner too. Making this a block would
      // stop customers checking out over a rule nobody has been enforcing, based on
      // wattage data that is 91% complete on CPUs and 72% on GPUs.
      severity: "warn",
      check(state, ctx) {
        const draw = Math.round(sumOverBuild(state, (p) => p.specs.wattsPerUnit));
        const supplied = Math.round(sumOverBuild(state, (p) => p.specs.wattsSupply));
        const needed = requiredWatts(draw, ctx);
        if (draw <= 0 || supplied <= 0 || needed <= supplied)
          return null;
        const psuSlot = ctx.roles.psu;
        const psus = partsInSlot(state, psuSlot);
        return {
          slots: [psuSlot],
          parts: psus.map((p) => p.id),
          message: `Power: needs ${needed}W, PSU supplies ${supplied}W`,
          detail: `draw ${draw}W -> requires ${needed}W > ${supplied}W supplied`
        };
      }
    }
  ];
  BUILD_RULES.push(
    {
      id: "ram_mobo_capacity",
      // BLOCK, as of PR 7b. This was the one rule shipped deliberately soft, and the
      // reason it could be promoted is that the census found the fear was misplaced.
      //
      // What it replaces let essentially everything through. The theme compared ONE
      // module against the cap (R16 in the pre-PR-0b resolveConflicts, preserved in
      // __reference__/theme-v2-rules.js:385), so it fired only for a single stick
      // larger than the whole board's ceiling. PrestaShop is worse still: it reads one
      // arbitrary memory line via GROUP BY ... LIMIT 1 with no ORDER BY
      // (Cart.php:418-440) and has the module multiplier COMMENTED OUT
      // (Product.php:1164), so a 512GB kit is judged as 64GB and the cap never fires.
      //
      // Summing it correctly therefore rejects builds that pass today, which is why
      // §5 asked for the newly-blocked list before enforcing. Measured 2026-08-21
      // over every (board x memory-variant) pair on all eight builds with slots
      // (toolkit/census_ram_capacity.mjs, run against this bundle):
      //
      //     9,522 pairs, 36 blocked (0.4%)
      //     CUSTOMER-VISIBLE blocked pairs: 0
      //     memory variants unsellable:     0
      //     default_selection failures:     0
      //
      // All 36 sit behind boards with display_in_configurator false, and most are
      // 2-DIMM boards where a 64GB ceiling is correct and refusing a 128GB kit is the
      // rule working. The 24 visible blocks the first census found all traced to ONE
      // board carrying max_memory_size 32 with four DDR5 slots, whose cap has since
      // been cleared as unknowable rather than guessed.
      //
      // Caveat worth keeping: 25 of about 110 boards have no cap at all (17 absent, 7
      // storing 0, plus that one), so this rule does not check them. Unchecked is the
      // pre-existing state, not a regression, but "we enforce memory capacity" is not
      // yet true of the whole catalogue.
      severity: "block",
      check(state, ctx) {
        const installed = installedMemoryGb(state, ctx);
        if (installed <= 0)
          return null;
        let cap = null;
        for (const b of partsInSlot(state, ctx.roles.board)) {
          const v = posNum(b.specs.maxMemorySizeGb);
          if (v != null)
            cap = Math.max(cap ?? 0, v);
        }
        if (cap == null || installed <= cap)
          return null;
        const ram = partsInSlot(state, ctx.roles.ram);
        return {
          slots: [ctx.roles.ram],
          parts: ram.map((p) => p.id),
          message: `Exceeds the motherboard's ${cap} GB limit (${installed} GB selected)`,
          detail: `${installed}GB > ${cap}GB`
        };
      },
      // A REMEDY IS NOT OPTIONAL HERE, which is the opposite of what I first
      // recommended when promoting this.
      //
      // plan() skips any block whose remedyFor yields nothing (explain.ts:282), and
      // the theme's canAddToCart is presence-only — it never consults evaluate().ok.
      // So a block with no remedy would leave an over-capacity build sitting in the
      // configurator, unresolvable and still addable to cart. Strictly worse than the
      // warning it replaced.
      //
      // And the state IS reachable, because greying out cannot prevent it: this rule
      // names only the MEMORY parts, so a low-cap board is never greyed on account of
      // the RAM already chosen — and the theme suppresses that whole direction anyway
      // (SUPPRESSED_REASONS in configurator-v2.js). Pick a 128GB kit, then switch to a
      // 64GB board, and nothing stopped you.
      //
      // Removal matches both prior implementations: R16 did `delete selections.memory`
      // with a force message, and PrestaShop deletes outright. `check` names every
      // memory line and plan() removes v.parts[0] then re-evaluates, so a multi-line
      // slot drains until the build fits rather than being cleared.
      //
      // Not `replace`: silently swapping in a smaller kit would re-price the build
      // downward without asking, which is the mirror of the PSU-upgrade hazard §5
      // spent so long guarding against.
      remedyFor: (v) => v.slots[0] ? { kind: "remove", slot: v.slots[0] } : null,
      notice: (v) => `Removed the memory \u2014 ${v.message.toLowerCase()}.`
    },
    {
      id: "slot_budget",
      // BLOCK. PrestaShop actively removes over-budget parts
      // (Cart::verifyCountTotals -> Cart.php:1727+), so this is not advisory. Unlike
      // wattage, it is also a hard physical fact: a fifth drive cannot occupy a
      // fourth port.
      severity: "block",
      check(state, ctx) {
        const budgets = computeBudgets(state, ctx);
        const over = overBudget(budgets);
        if (!over.length)
          return null;
        const b = over[0];
        const offender = b.consumers[b.consumers.length - 1] ?? null;
        return {
          slots: offender ? [offender.slot] : [],
          parts: offender ? [offender.id] : [],
          message: `Not enough ${b.label} (needs ${b.used}, ${b.supply} available)`,
          detail: `${b.key}: ${b.used} > ${b.supply}${b.clamped ? " (clamped by SATA ports)" : ""}`
        };
      },
      // Remove the line that overflowed the pool, not the whole slot — four drives
      // where the fifth does not fit is one drive too many, not a reason to clear
      // storage. `check` names the last-added consumer for exactly this reason.
      remedyFor: (v) => v.slots[0] ? { kind: "remove", slot: v.slots[0] } : null,
      notice: (v) => `Removed a part \u2014 ${v.message.toLowerCase()}.`
    },
    {
      id: "slot_quantity",
      severity: "block",
      check(state, ctx) {
        const units = unitsBySlot(state);
        for (const slot of Object.keys(ctx.slotLimits)) {
          const limit = ctx.slotLimits[slot];
          if (limit == null || limit <= 0)
            continue;
          const used = units.get(slot) ?? 0;
          if (used <= limit)
            continue;
          const lines = partsInSlot(state, slot);
          const offender = lines[lines.length - 1];
          return {
            slots: [slot],
            parts: offender ? [offender.id] : [],
            message: `Only ${limit} allowed in this step (${used} selected)`,
            detail: `${slot}: ${used} > ${limit}`
          };
        }
        return null;
      },
      remedyFor: (v) => v.slots[0] ? { kind: "remove", slot: v.slots[0] } : null,
      notice: (v) => `Removed a part \u2014 ${v.message.toLowerCase()}.`
    },
    {
      id: "combo_duplicate",
      /**
       * A keyboard+mouse COMBO already contains the mouse, so offering mice sells a
       * second one.
       *
       * THE ONLY DUPLICATION RULE. The other nine are part-FIT rules: does A
       * physically work with B. This one asks whether one product already contains
       * what another slot is selling — a class PrestaShop has no concept of, and
       * which the audit therefore never surfaced. Ported from the theme
       * (configurator-v2.js `isKbMouseCombo` + the `mouse` case of compatReason),
       * which records its origin: Sales, 2026-08-18, "Mouse not being removed when
       * keyboard and mouse combo selected" — customers were being sold TWO MICE.
       *
       * WHY THE ENGINE HAD TO GROW IT. Without it, wiring the theme to this engine
       * (PR 0b) would revert a fix that exists because customers were over-charged.
       * The parity suite caught the gap.
       *
       * SCOPE THIS OUT OF THE CHECKOUT FUNCTION. It is not a physical block — a
       * combo plus a spare mouse is a machine that works, bought by someone who
       * chose to pay for both. Refusing that sale at checkout is worse for everyone
       * than shipping a spare mouse, and the function's agreed scope is physical
       * blocks. `enabledRules` already makes that a per-surface config choice.
       */
      severity: "block",
      check(state, ctx) {
        const mouseSlot = ctx.roles.mouse;
        const keyboardSlot = ctx.roles.keyboard;
        if (!mouseSlot || !keyboardSlot)
          return null;
        const mice = partsInSlot(state, mouseSlot);
        if (!mice.length)
          return null;
        const combo = partsInSlot(state, keyboardSlot).find(isComboProduct);
        if (!combo)
          return null;
        return {
          // The MOUSE is named, not the keyboard: it is the redundant purchase, and
          // naming it is what makes explainCandidate grey out mice rather than
          // keyboards.
          slots: [mouseSlot],
          parts: mice.map((m) => m.id),
          message: "Already included with your keyboard + mouse combo",
          detail: `combo: ${combo.sku || combo.label}`
        };
      },
      /**
       * REMOVE the mouse — which is what the theme actually does.
       *
       * #123 shipped this rule with no remedy, on the stated grounds that it was
       * "matching the theme, which prevents the SELECTION rather than deleting a part
       * the customer already has". That was read off `compatReason` and it was wrong:
       * `resolveConflicts` deletes the mouse outright, with
       * "Removed <name> — your keyboard + mouse combo already includes one."
       * The mutating-half parity suite (#125) caught it.
       *
       * The mouse, never the keyboard: the combo is the purchase the customer wants,
       * and the separate mouse is the redundant one. `check` names every mouse, and
       * plan() removes one per pass, so a multi-select slot drains over successive
       * iterations rather than needing a bulk remedy.
       */
      remedyFor: (v) => v.slots[0] ? { kind: "remove", slot: v.slots[0] } : null,
      notice: () => "Removed the mouse \u2014 your keyboard + mouse combo already includes one."
    }
  );
  function isComboProduct(p) {
    const hay = [p.label, p.sku].join(" ").toUpperCase();
    return /COMBO|KB\/MOU|KEYBOARD\s*(?:\+|AND|&)\s*MOUSE|MOUSE\s*(?:\+|AND|&)\s*KEYBOARD/.test(hay);
  }
  var BUILD_RULES_BY_ID = Object.fromEntries(
    BUILD_RULES.map((r) => [r.id, r])
  );
  ALL_RULE_IDS.push(...RULES.map((r) => r.id), ...BUILD_RULES.map((r) => r.id));

  // app/lib/compat/requirements.ts
  function requiredSlots(ctx) {
    return Object.keys(ctx.requirements).filter((slot) => {
      const r = ctx.requirements[slot];
      return r != null && (r.required || r.groupRequired === true);
    });
  }
  function missingRequirements(state, ctx) {
    const filled = new Set(state.parts.map((p) => p.slot));
    const buckets = /* @__PURE__ */ new Map();
    for (const slot of requiredSlots(ctx)) {
      const r = ctx.requirements[slot];
      const key = r.group ?? slot;
      const existing = buckets.get(key);
      if (existing) {
        existing.slots.push(slot);
        continue;
      }
      buckets.set(key, { label: r.label, slots: [slot] });
    }
    const missing = [];
    for (const [key, bucket] of buckets) {
      if (bucket.slots.some((s) => filled.has(s)))
        continue;
      missing.push({ key, label: bucket.label, satisfiedBy: bucket.slots.slice() });
    }
    return missing;
  }
  function missingRequirementsMessage(missing) {
    const labels = missing.map((m) => m.label);
    const section = labels.length > 1 ? "sections" : "section";
    return `Your build still needs a selection from the following ${section}: ${labels.join(", ")}`;
  }
  function readiness(state, ctx) {
    const { ok: compatible, violations } = evaluate(state, ctx);
    const missing = missingRequirements(state, ctx);
    return {
      ok: compatible && missing.length === 0,
      compatible,
      complete: missing.length === 0,
      violations,
      missing
    };
  }

  // app/lib/compat/index.ts
  var COMPAT_ENGINE_VERSION = "0.1.0";
  function checkRule(ctx, rule, bySlot, enabled) {
    if (!enabled.has(rule.id))
      return [];
    const subjectSlot = ctx.roles[rule.subject];
    const counterpartSlot = ctx.roles[rule.counterpart];
    const subjects = bySlot.get(subjectSlot);
    const counterparts = bySlot.get(counterpartSlot);
    if (!subjects || !counterparts)
      return [];
    const out = [];
    for (const subject of subjects) {
      for (const counterpart of counterparts) {
        if (!rule.fires(subject.specs, counterpart.specs)) {
          if (ctx.reportUnverified && rule.missingSpecs) {
            const missing = rule.missingSpecs(subject.specs, counterpart.specs);
            if (missing.length) {
              out.push({
                rule: rule.id,
                severity: "unverified",
                slots: [subjectSlot, counterpartSlot],
                parts: [subject.id, counterpart.id],
                message: `${rule.id} could not be checked \u2014 missing ${missing.join(", ")}`,
                missing
              });
            }
          }
          continue;
        }
        out.push({
          rule: rule.id,
          severity: rule.severity,
          slots: [subjectSlot, counterpartSlot],
          parts: [subject.id, counterpart.id],
          message: rule.reason(subject.specs, counterpart.specs),
          detail: rule.detail?.(subject.specs, counterpart.specs)
        });
      }
    }
    return out;
  }
  function evaluate(state, ctx) {
    const violations = [];
    const bySlot = indexBySlot(state);
    const enabled = new Set(ctx.enabledRules);
    for (const rule of RULES) {
      const found = checkRule(ctx, rule, bySlot, enabled);
      for (let i = 0; i < found.length; i++)
        violations.push(found[i]);
    }
    for (const rule of BUILD_RULES) {
      if (!enabled.has(rule.id))
        continue;
      const found = rule.check(state, ctx);
      if (found)
        violations.push({ rule: rule.id, severity: rule.severity, ...found });
    }
    return { ok: !violations.some((v) => v.severity === "block"), violations };
  }

  // app/lib/compat/capacity.ts
  var CAPACITY_RULES = ["slot_budget", "slot_quantity"];
  var DEFAULT_PROBE = 16;
  function inertPart(slot, id) {
    return {
      id,
      slot,
      label: "probe",
      price: 0,
      available: true,
      lineQty: 1,
      unitsPerVariant: 1,
      specs: {}
    };
  }
  function slotCapacity(state, ctx, slot, candidate, opts = {}) {
    const max = opts.probe ?? DEFAULT_PROBE;
    const used = unitsBySlot(state).get(slot) ?? 0;
    const probeCtx = { ...ctx, enabledRules: CAPACITY_RULES };
    const sample = candidate ?? state.parts.find((p) => p.slot === slot) ?? inertPart(slot, "__probe_sample");
    for (let n = 1; n <= max; n++) {
      const added = [];
      for (let i = 0; i < n; i++) {
        added.push({ ...sample, id: "__probe#" + i, lineQty: 1 });
      }
      const hit = evaluate({ parts: state.parts.concat(added) }, probeCtx).violations.find(
        (v) => CAPACITY_RULES.includes(v.rule) && v.slots.includes(slot)
      );
      if (hit) {
        return {
          used,
          headroom: n - 1,
          limit: used + (n - 1),
          stoppedBy: hit.rule,
          message: hit.message
        };
      }
    }
    return { used, headroom: null, limit: null, stoppedBy: null, message: null };
  }
  function canAdd(state, ctx, slot, candidate, delta = 1) {
    if (delta <= 0)
      return true;
    const cap = slotCapacity(state, ctx, slot, candidate, { probe: delta });
    return cap.headroom == null || cap.headroom >= delta;
  }

  // app/lib/compat/psu.ts
  function powerBalance(state, ctx) {
    const draw = Math.round(sumOverBuild(state, (p) => p.specs.wattsPerUnit));
    return {
      draw,
      // The MARGINATED figure, from the same helper the psu_wattage rule uses, so the
      // rule and the upgrade can never disagree about what the build needs. Policy
      // defaults match the theme's live 100W + 1.3x (configurator-v2.js:577-591).
      needed: requiredWatts(draw, ctx),
      supplied: Math.round(sumOverBuild(state, (p) => p.specs.wattsSupply))
    };
  }
  function smallestSufficientPsu(catalog, ctx, neededWatts, psuClearanceMm) {
    const candidates = catalog.filter((p) => {
      if (p.slot !== ctx.roles.psu)
        return false;
      if (!p.available)
        return false;
      const supply = posNum(p.specs.wattsSupply);
      if (supply == null || supply <= neededWatts)
        return false;
      if (psuClearanceMm != null) {
        const len = posNum(p.specs.lengthMm);
        if (len != null && len > psuClearanceMm)
          return false;
      }
      return true;
    });
    candidates.sort((a, b) => {
      const aw = posNum(a.specs.wattsSupply) ?? 0;
      const bw = posNum(b.specs.wattsSupply) ?? 0;
      if (aw !== bw)
        return aw - bw;
      if (a.price !== b.price)
        return a.price - b.price;
      return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
    });
    return candidates[0] ?? null;
  }
  function decidePsuUpgrade(state, catalog, ctx, trigger) {
    if (ctx.systemType === "laptop")
      return { ok: false, reason: "not-applicable" };
    if (!ctx.policy.psuAutoUpgrade)
      return { ok: false, reason: "policy-off" };
    if (trigger !== "user")
      return { ok: false, reason: "not-user-initiated" };
    const { draw, needed, supplied } = powerBalance(state, ctx);
    if (draw <= 0 || supplied <= 0 || needed <= supplied) {
      return { ok: false, reason: "not-applicable" };
    }
    const chassis = partsInSlot(state, ctx.roles.chassis)[0] ?? null;
    const clearance = chassis ? posNum(chassis.specs.clearance?.psuMm) : null;
    const to = smallestSufficientPsu(catalog, ctx, needed, clearance);
    if (!to)
      return { ok: false, reason: "no-candidate" };
    const existing = partsInSlot(state, ctx.roles.psu);
    const from = existing.slice().sort((a, b) => (posNum(a.specs.wattsSupply) ?? 0) - (posNum(b.specs.wattsSupply) ?? 0))[0] ?? null;
    if (from) {
      const fromWatts = posNum(from.specs.wattsSupply) ?? 0;
      const toWatts = posNum(to.specs.wattsSupply) ?? 0;
      if (toWatts <= fromWatts)
        return { ok: false, reason: "no-candidate" };
    }
    if (to.id === from?.id)
      return { ok: false, reason: "no-candidate" };
    const deltaCents = to.price - (from?.price ?? 0);
    const upgrade = { to, from, neededWatts: needed, deltaCents };
    const cap = ctx.policy.psuUpgradeMaxDeltaCents;
    if (cap != null && deltaCents > cap) {
      return { ok: false, reason: "over-delta-cap", candidate: upgrade };
    }
    return { ok: true, upgrade };
  }
  function psuUpgradeNotice(u) {
    return `For your selected components, we've upgraded the power supply to ${u.to.label} so it can deliver the ${u.neededWatts}W this build needs.`;
  }
  function psuUpgradePromptNotice(u) {
    return `This build needs ${u.neededWatts}W. ${u.to.label} would cover it \u2014 choose it, or a different power supply, to continue.`;
  }

  // app/lib/compat/explain.ts
  function place(state, candidate, ctx) {
    if (ctx.multiSelectSlots.includes(candidate.slot)) {
      return { parts: state.parts.concat([candidate]) };
    }
    return {
      parts: state.parts.filter((p) => p.slot !== candidate.slot).concat([candidate])
    };
  }
  function withoutPart(state, partId) {
    return { parts: state.parts.filter((p) => p.id !== partId) };
  }
  function replacePart(state, partId, replacement) {
    return { parts: state.parts.map((p) => p.id === partId ? replacement : p) };
  }
  function partById(state, id) {
    return state.parts.find((p) => p.id === id) ?? null;
  }
  function offendingPartId(v, slot) {
    const i = v.slots.indexOf(slot);
    return i >= 0 ? v.parts[i] ?? null : null;
  }
  function explainCandidate(candidate, state, ctx) {
    if (ctx.autoswapSlots.includes(candidate.slot))
      return [];
    const hypothetical = place(state, candidate, ctx);
    return evaluate(hypothetical, ctx).violations.filter(
      // BLOCKS only. A warning must never grey out a card: the wattage rule fires on
      // the whole build, so including warnings here would mark every PSU option
      // "unavailable" the moment a build drew more than one of them supplies —
      // including the ones that would fix it.
      (v) => v.severity === "block" && v.parts.includes(candidate.id)
    );
  }
  function candidateReason(candidate, state, ctx) {
    const [first] = explainCandidate(candidate, state, ctx);
    return first ? first.message : null;
  }
  function cheapestSatisfying(catalog, slot, rule, counterpart, subjectIsCounterpartSide, keep) {
    const candidates = catalog.filter((p) => p.slot === slot).slice().sort((a, b) => a.price - b.price);
    let fallback = null;
    for (const c of candidates) {
      const fires = subjectIsCounterpartSide ? rule.fires(counterpart.specs, c.specs) : rule.fires(c.specs, counterpart.specs);
      if (fires)
        continue;
      if (!ruleDecidable(rule, c, counterpart, subjectIsCounterpartSide))
        continue;
      if (!keep)
        return c;
      fallback ?? (fallback = c);
      const swapped = replacePart(keep.state, keep.targetId, c);
      const clashes = evaluate(swapped, keep.ctx).violations.some(
        (v) => v.severity === "block" && v.parts.includes(c.id)
      );
      if (!clashes)
        return c;
    }
    return fallback;
  }
  function decidableAgainstBuild(candidate, state, ctx) {
    for (const rule of RULES) {
      if (!ctx.enabledRules.includes(rule.id))
        continue;
      const subjectSlot = ctx.roles[rule.subject];
      const counterpartSlot = ctx.roles[rule.counterpart];
      const isSubject = subjectSlot === candidate.slot;
      const isCounterpart = counterpartSlot === candidate.slot;
      if (!isSubject && !isCounterpart)
        continue;
      const otherSlot = isSubject ? counterpartSlot : subjectSlot;
      for (const other of state.parts) {
        if (other.slot !== otherSlot)
          continue;
        if (!ruleDecidable(rule, candidate, other, isCounterpart))
          return false;
      }
    }
    return true;
  }
  function cheapestFitting(catalog, slot, state, ctx) {
    const candidates = catalog.filter((p) => p.slot === slot).slice().sort((a, b) => a.price - b.price);
    for (const c of candidates) {
      if (evaluate(place(state, c, ctx), ctx).violations.some((v) => v.severity === "block"))
        continue;
      if (!decidableAgainstBuild(c, state, ctx))
        continue;
      return c;
    }
    return null;
  }
  function ruleDecidable(rule, candidate, counterpart, subjectIsCounterpartSide) {
    const subject = subjectIsCounterpartSide ? counterpart.specs : candidate.specs;
    const other = subjectIsCounterpartSide ? candidate.specs : counterpart.specs;
    switch (rule.id) {
      case "cpu_mobo_socket":
        return !!(subject.socket || [])[0] && !!(other.socket || [])[0];
      case "cpu_mobo_chipset":
        return !!subject.chipsetVendor && !!other.chipsetVendor;
      case "mobo_case_form_factor":
        return (subject.formFactor || []).length > 0 && (other.formFactor || []).length > 0;
      case "ram_mobo_type":
        return (subject.memoryType || []).length > 0 && (other.memoryType || []).length > 0;
      default:
        return true;
    }
  }
  var MAX_ITERATIONS = 6;
  function plan(state, catalog, lastChangedSlot, ctx, opts = {}) {
    let current = { parts: state.parts.slice() };
    const actions = [];
    const notices = [];
    let psuUpgradeTried = false;
    let iterations = 0;
    let changed = true;
    while (changed && iterations < MAX_ITERATIONS) {
      changed = false;
      iterations++;
      const { violations } = evaluate(current, ctx);
      for (const v of violations) {
        if (v.rule === "psu_wattage" && !psuUpgradeTried) {
          psuUpgradeTried = true;
          const outcome = decidePsuUpgrade(current, catalog, ctx, opts.trigger);
          if (outcome.ok) {
            const { upgrade } = outcome;
            current = upgrade.from ? replacePart(current, upgrade.from.id, upgrade.to) : place(current, upgrade.to, ctx);
            actions.push({
              rule: "psu_wattage",
              slot: ctx.roles.psu,
              kind: "replaced",
              toPartId: upgrade.to.id
            });
            notices.push({
              rule: "psu_wattage",
              slot: ctx.roles.psu,
              text: psuUpgradeNotice(upgrade),
              // Not `force`: this is something we did FOR them, not something they
              // must fix. The over-cap prompt below is the opposite.
              force: false
            });
            changed = true;
            break;
          }
          if (outcome.reason === "over-delta-cap" && outcome.candidate) {
            notices.push({
              rule: "psu_wattage",
              slot: ctx.roles.psu,
              text: psuUpgradePromptNotice(outcome.candidate),
              force: true
            });
            actions.push({ rule: "psu_wattage", slot: ctx.roles.psu, kind: "advised" });
          }
          continue;
        }
        if (v.severity !== "block")
          continue;
        const buildRule = BUILD_RULES_BY_ID[v.rule];
        if (buildRule) {
          const remedy2 = buildRule.remedyFor?.(v, ctx);
          if (!remedy2 || remedy2.kind !== "remove")
            continue;
          const targetId2 = v.parts[0];
          const target2 = targetId2 ? partById(current, targetId2) : partInSlot(current, remedy2.slot);
          if (!target2)
            continue;
          current = withoutPart(current, target2.id);
          actions.push({ rule: v.rule, slot: remedy2.slot, kind: "removed" });
          notices.push({
            rule: v.rule,
            slot: remedy2.slot,
            text: buildRule.notice?.(v) ?? v.message,
            force: true
          });
          changed = true;
          break;
        }
        const rule = RULES_BY_ID[v.rule];
        if (!rule)
          continue;
        const remedy = rule.remedyFor(ctx, lastChangedSlot);
        const subjectSlot = ctx.roles[rule.subject];
        const counterpartSlot = ctx.roles[rule.counterpart];
        if (remedy.kind === "manual") {
          notices.push({ rule: rule.id, slot: remedy.slot, text: manualText(rule, ctx), force: true });
          actions.push({ rule: rule.id, slot: remedy.slot, kind: "advised" });
          continue;
        }
        const targetId = offendingPartId(v, remedy.slot);
        const target = targetId ? partById(current, targetId) : partInSlot(current, remedy.slot);
        const anchorSlot = remedy.slot === subjectSlot ? counterpartSlot : subjectSlot;
        const anchorId = offendingPartId(v, anchorSlot);
        const anchor = (anchorId ? partById(current, anchorId) : null) ?? partInSlot(current, anchorSlot);
        if (!anchor || !target)
          continue;
        if (remedy.kind === "replace") {
          const replacement = cheapestSatisfying(
            catalog,
            remedy.slot,
            rule,
            anchor,
            remedy.slot === subjectSlot ? false : true,
            { state: current, targetId: target.id, ctx }
          );
          if (replacement) {
            current = replacePart(current, target.id, replacement);
            actions.push({ rule: rule.id, slot: remedy.slot, kind: "replaced", toPartId: replacement.id });
            notices.push({
              rule: rule.id,
              slot: remedy.slot,
              text: rule.notice(
                remedy.slot === subjectSlot ? replacement.specs : anchor.specs,
                remedy.slot === subjectSlot ? anchor.specs : replacement.specs,
                replacement.label
              ),
              force: false
            });
          } else {
            current = withoutPart(current, target.id);
            actions.push({ rule: rule.id, slot: remedy.slot, kind: "removed" });
            notices.push({
              rule: rule.id,
              slot: remedy.slot,
              text: rule.notice(target.specs, anchor.specs),
              force: true
            });
          }
          changed = true;
          break;
        }
        current = withoutPart(current, target.id);
        actions.push({ rule: rule.id, slot: remedy.slot, kind: "removed" });
        notices.push({
          rule: rule.id,
          slot: remedy.slot,
          text: rule.notice(target.specs, anchor.specs),
          force: true
        });
        changed = true;
        break;
      }
    }
    return {
      state: current,
      actions,
      notices,
      iterations,
      exhausted: changed && iterations >= MAX_ITERATIONS
    };
  }
  function manualText(rule, _ctx) {
    if (rule.id === "mobo_case_form_factor") {
      return "The selected case won't fit this motherboard; pick a larger case.";
    }
    return rule.notice({}, {});
  }

  // app/lib/compat/adapters/xidax.ts
  var XIDAX_SLOTS = {
    chassis: "cases",
    cpu: "processors",
    board: "motherboards",
    cooler: "cpu-cooling",
    ram: "memory",
    gpu: "graphics-cards",
    psu: "power-supplies"
  };
  var THERMAL_SLOTS = /* @__PURE__ */ new Set([
    XIDAX_SLOTS.cooler,
    // cooling_group: 'watercooling' on xidax_slot, and the loop parts that carry a
    // capacity figure. Fittings, coolant and tubing are in that group too but record
    // no wattage at all, so listing them would be noise.
    "cpu-waterblock",
    "gpu-waterblock",
    "radiator",
    "pump-reservoir"
  ]);
  var XIDAX_MULTI_SELECT_SLOTS = [
    XIDAX_SLOTS.ram,
    XIDAX_SLOTS.gpu,
    "ssd-m2-nvme",
    "ssd-sata",
    "hard-drives",
    "case-fans",
    "monitors",
    "keyboard",
    "mouse",
    "headset",
    "speakers",
    "led-lighting"
  ];
  function put(out, key, raw) {
    if (raw == null || raw === "")
      return;
    const v = num(raw);
    if (v != null)
      out[key] = v;
  }
  function boardBudgets(c) {
    const o = {};
    put(o, "pcie", c.pcie_slot_count);
    put(o, "sata", c.sata_slot_count);
    put(o, "m2_nvme", c.m2_nvme_slot_count);
    put(o, "m2_sata", c.m2_sata_slot_count);
    put(o, "m2_combo", c.m2_combo_slot_count);
    put(o, "dimms", c.memory_dimms);
    put(o, "cpus", c.cpu_socket_count);
    return o;
  }
  function chassisBudgets(c) {
    const o = {};
    put(o, "case_fans", c.case_fan_slot_count);
    put(o, "bay_25", c.slot_count_25);
    put(o, "bay_35", c.slot_count_35);
    put(o, "bay_525", c.slot_count_525);
    put(o, "dimms", c.memory_dimms);
    return o;
  }
  function usesOf(c, isRam) {
    const o = {};
    put(o, "pcie", c.pcie_slot_count);
    put(o, "sata", c.sata_slot_count);
    put(o, "m2_nvme", c.m2_nvme_slot_count);
    put(o, "m2_sata", c.m2_sata_slot_count);
    put(o, "cpus", c.cpu_socket_count);
    put(o, "case_fans", c.case_fan_slot_count);
    put(o, "bay_25", c.slot_count_25);
    put(o, "bay_35", c.slot_count_35);
    put(o, "bay_525", c.slot_count_525);
    if (isRam)
      o.dimms = 1;
    return o;
  }
  function toSpecs(compat, slot) {
    const c = compat || {};
    const isChassis = slot === XIDAX_SLOTS.chassis;
    const isBoard = slot === XIDAX_SLOTS.board;
    const isRam = slot === XIDAX_SLOTS.ram;
    const watts = posNum(c.wattage_requirement);
    return {
      socket: asList(c.socket_type),
      chipsetVendor: c.chipset_manufacturer || null,
      formFactor: asList(c.motherboard_form_factor),
      memoryType: asList(c.memory_type),
      memorySizeGb: posNum(c.memory_size),
      maxMemorySizeGb: posNum(c.max_memory_size),
      // A chassis's *_length values are clearances, not its own dimensions.
      lengthMm: isChassis ? null : posNum(c.gpu_length) ?? posNum(c.psu_length),
      heightMm: isChassis ? null : posNum(c.max_cpu_cooler_height),
      clearance: isChassis ? {
        gpuMm: posNum(c.gpu_length),
        psuMm: posNum(c.psu_length),
        coolerMm: posNum(c.max_cpu_cooler_height)
      } : null,
      // The overload split. A cooler gets thermal capacity and NO draw; everything
      // else gets draw and no thermal capacity.
      wattsPerUnit: THERMAL_SLOTS.has(slot) ? null : watts,
      thermalWatts: THERMAL_SLOTS.has(slot) ? watts : null,
      wattsSupply: posNum(c.wattage_supply),
      // SUPPLY vs CONSUMPTION is decided by the SLOT, from the same metafield keys.
      //
      // PrestaShop stores both sides of every budget in one column: a board's
      // `sata_slot_count` is "I have 4 ports", a drive's is "I need 1". Identical to
      // gpu_length being a clearance on a chassis and a dimension on a card. It
      // distinguishes them with a per-measure `filter` naming the supplying category
      // (Product.php:1359-1364); here the slot does it, so no rule has to.
      //
      // Populating only the relevant side means a mis-slotted part cannot
      // accidentally supply capacity it does not have.
      budgets: isBoard ? boardBudgets(c) : isChassis ? chassisBudgets(c) : {},
      uses: isBoard || isChassis ? {} : usesOf(c, isRam)
    };
  }
  function toPart(line) {
    const specs = toSpecs(line.compat, line.slot);
    const part = {
      id: line.id,
      slot: line.slot,
      label: line.label,
      price: line.price,
      available: line.available !== false,
      lineQty: line.lineQty ?? 1,
      // The kit multiplier. Emitted today as `attribute_quantity` and read by
      // nothing — PR 1 makes it count.
      unitsPerVariant: posNum(line.compat?.attribute_quantity) ?? 1,
      specs
    };
    if (line.sku != null)
      part.sku = line.sku;
    return part;
  }
  var XIDAX_SLOT_LIMITS = {
    monitors: 4,
    webcam: 5,
    keyboard: 5,
    mouse: 5,
    headset: 5,
    "mouse-pad": 5,
    speakers: 5,
    "led-lighting": 2
  };
  var XIDAX_REQUIREMENTS = {
    [XIDAX_SLOTS.chassis]: { required: true, label: "Case" },
    [XIDAX_SLOTS.cpu]: { required: true, label: "Processors" },
    [XIDAX_SLOTS.board]: { required: true, label: "Motherboards" },
    [XIDAX_SLOTS.ram]: { required: true, label: "Memory" },
    [XIDAX_SLOTS.gpu]: { required: true, label: "Graphics Cards" },
    [XIDAX_SLOTS.cooler]: { required: true, label: "CPU Cooling" },
    [XIDAX_SLOTS.psu]: { required: true, label: "Power Supplies" },
    "case-fans": { required: true, label: "Case Fans" },
    "operating-systems": { required: true, label: "Operating Systems" },
    "anti-virus": { required: true, label: "Anti-Virus" },
    // The one real group. Reported as "Storage", never as one member's name.
    "ssd-m2-nvme": { required: true, group: "storage", groupRequired: true, label: "Storage" },
    "ssd-sata": { required: false, group: "storage", groupRequired: true, label: "Storage" },
    "hard-drives": { required: false, group: "storage", groupRequired: true, label: "Storage" }
  };
  var XIDAX_LAPTOP_REQUIREMENTS = {
    // The barebone: chassis, CPU and GPU in one selection.
    [XIDAX_SLOTS.chassis]: { required: true, label: "Laptop" },
    [XIDAX_SLOTS.ram]: { required: true, label: "Memory" },
    "operating-systems": { required: true, label: "Operating Systems" },
    "anti-virus": { required: true, label: "Anti-Virus" },
    "ssd-m2-nvme": { required: true, group: "storage", groupRequired: true, label: "Storage" }
  };
  var XIDAX_REQUIREMENT_GROUPS = [
    { id: "storage", label: "Storage", members: ["ssd-m2-nvme", "ssd-sata", "hard-drives"] }
  ];
  function requirementsFromSlots(slots, groups = XIDAX_REQUIREMENT_GROUPS) {
    const out = {};
    const present = /* @__PURE__ */ new Set();
    for (const s of slots || []) {
      if (!s || !s.handle)
        continue;
      present.add(s.handle);
      if (!s.isRequired)
        continue;
      out[s.handle] = { required: true, label: s.label || s.handle };
    }
    for (const g of groups) {
      const members = g.members.filter((m) => present.has(m));
      if (!members.length)
        continue;
      if (!members.some((m) => out[m]?.required))
        continue;
      for (const m of members) {
        out[m] = { required: false, group: g.id, groupRequired: true, label: g.label };
      }
    }
    return out;
  }
  function xidaxContext(overrides = {}) {
    return {
      systemType: "desktop",
      roles: {
        board: XIDAX_SLOTS.board,
        chassis: XIDAX_SLOTS.chassis,
        cpu: XIDAX_SLOTS.cpu,
        cooler: XIDAX_SLOTS.cooler,
        psu: XIDAX_SLOTS.psu,
        ram: XIDAX_SLOTS.ram,
        gpu: XIDAX_SLOTS.gpu,
        mouse: "mouse",
        keyboard: "keyboard"
      },
      enabledRules: ALL_RULE_IDS,
      // TWO slots, matching the theme's AUTOSWAP_SLOTS (configurator-v2.js:156).
      //
      // PR 0a listed three — cpu, board, chassis — and claimed the set was "carried
      // over verbatim ... preserving the exact set is what keeps this extraction
      // behaviour-neutral". It was not verbatim: the theme's set is
      // {processors, cases} and the engine had added motherboards. Consequence, found
      // by parity.test.ts: the theme greys out an incompatible MOTHERBOARD, and the
      // engine did not, so wiring the theme to the engine would have silently stopped
      // greying out boards that do not fit the case or the CPU.
      autoswapSlots: [XIDAX_SLOTS.cpu, XIDAX_SLOTS.chassis],
      multiSelectSlots: XIDAX_MULTI_SELECT_SLOTS,
      slotLimits: { ...XIDAX_SLOT_LIMITS },
      requirements: { ...XIDAX_REQUIREMENTS },
      // MATCHES LIVE. The theme already auto-upgrades the PSU unconditionally
      // (the pre-0b resolveConflicts, configurator-v2.js:702) and applies a 100W + 1.3x headroom
      // (:577-591) — both live and load-bearing, so defaulting them off or to zero
      // would quietly stop an upsell the store performs today.
      //
      // The trigger guard is NOT relaxed to match: the theme upgrades on restore and
      // seed too (resolveConflicts runs on the seed and restore paths), which is exactly how a
      // shared Config # gets silently re-priced. `trigger: "user"` is still required,
      // so this preserves the behaviour without the defect.
      policy: {
        psuAutoUpgrade: true,
        psuUpgradeMaxDeltaCents: null,
        psuMargin: 1.3,
        psuBaseOverheadW: 100
      },
      ...overrides
    };
  }
  return __toCommonJS(theme_entry_exports);
})();
